import { useMemo } from "react";
import type { AppRouteObject } from "#/router";
import { getRoutesFromModules } from "../utils"; // This should return static route definitions

const ROUTE_MODE = import.meta.env.VITE_APP_ROUTER_MODE;

/**
 * Return all routes without checking any permissions.
 * This completely bypasses user roles, status, or filters.
 */
export function usePermissionRoutes(): AppRouteObject[] {
	return useMemo(() => {
		// Optional: If you want to switch modes based on env
		if (ROUTE_MODE === "module") {
			return getRoutesFromModules(); // ✅ All routes from route modules
		}

		// Default fallback to module-based routes anyway
		return getRoutesFromModules();
	}, []);
}
